import { render, staticRenderFns } from "./FacilityEditTabEvent.vue?vue&type=template&id=15aeb152&"
import script from "./FacilityEditTabEvent.vue?vue&type=script&lang=js&"
export * from "./FacilityEditTabEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports